
export const validObj = { valid:true, errors:[] };

function getErrors(valid, vm){
  vm.valid = valid;
  return (valid) ? [] : [vm] ;
}

export function combineValidation(...args){
  return args.reduce(
    (ret, obj) => ({
      valid: ret.valid && obj.valid,
      errors: [...ret.errors, ...obj.errors]
    }), validObj);
}

export function finish(state, finishVM){
  let valid = !!(finishVM.selected && finishVM.selected.id);
  const errors = getErrors(valid, finishVM);
  return { valid, errors }
}

export function line(state, lineVM, otherLineVM, isConfirm){
  const otherVMActive = !!otherLineVM && !!otherLineVM.selected;
  const valid = !(lineVM.options.length > 0) || !!lineVM.selected || otherVMActive;
  const errors = getErrors(valid, lineVM);
  const paintable = lineVM.selected && lineVM.selected.parameterKeys;
  return combineValidation(
    { valid, errors } ,
    ...lineVM.paints.map(paintVM => ((paintable && isConfirm && paint(state, paintVM)) || validObj ) )
  )
}

export function paint(state, paintVM, enabled = true){
  let valid = !enabled || !!(paintVM.selected && paintVM.selected.id && 
    paintVM.paints.filter(paint => paint.id === paintVM.selected.id).length > 0
  );
  const errors = getErrors(valid, paintVM)
  return { valid, errors }
}

export function stamp(state, stampVM, isConfirm) {
  const enabled = stampVM.selected && stampVM.selected.enabled;
  const valid = !enabled || (enabled && !!stampVM.selected.stampId);
  const errors = getErrors(valid, stampVM);
  return combineValidation(
    { valid, errors },
    (enabled && isConfirm && paint(state, stampVM.paint)) || validObj
  )
}

export function initials(state, initialsVM, isConfirm) {
  const enabled = initialsVM.selected.enabled;
  const valid = !enabled || (
    enabled &&
    !!initialsVM.selected.characters.length &&
    !!initialsVM.selected.personalizationStyleId);
  const errors = getErrors(valid, initialsVM);
  return combineValidation(
    { valid, errors },
    (enabled && isConfirm && paint(state, initialsVM.paint)) || validObj
  );
}

export function engraving(state, engravingVM){
  const valid = !engravingVM.selected || !!engravingVM.selected.id 
  const errors = getErrors(valid, engravingVM);
  return { valid, errors }
} 
export function weightFront(state, weightVM){
  const e = weightVM.frontEngraving
  const p = weightVM.frontPaint
  return combineValidation(engraving(state, e), paint(stamp, p))
}
export function weightRear(state, weightVM){
  const e = weightVM.rearEngraving
  const p = weightVM.rearPaint
  return combineValidation(engraving(state, e), paint(stamp, p))
} 
export function weight(state, weightVM){
  const enabled = !!weightVM.selectedEngraving;
  //const valid = enabled ? !!(weightVM.selected && weightVM.selected.id) : true; 
  const valid = true; 
  const errors = getErrors(valid, weightVM);
  return combineValidation(
    { valid, errors },
    (enabled && weightFront(state, weightVM)) || validObj,
    (enabled && weightRear(state, weightVM)) || validObj
  );
}

export function reshaft(state, specsVM){
  let valid = true;
  if( 
    !buyAPutter &&
    (    (specsVM.length.selected && specsVM.length.selected.reshaftRequired) 
      || (specsVM.loft.selected && specsVM.loft.selected.reshaftRequired) 
      || (specsVM.lie.selected && specsVM.lie.selected.reshaftRequired)
      || !!specsVM.restoration 
    )
    )
  {
    valid = !!(specsVM.reshaft.selected && !specsVM.reshaft.selected.keepShaft);
  }
  const errors = getErrors(valid, specsVM.reshaft);
  return { valid, errors }
}

export function lie(state, specsVM){ 
  let valid = specsVM.lie.selected;
  const errors = getErrors(valid, specsVM.lie);
  return { valid, errors }
}

export function loft(state, specsVM){ 
  let valid = specsVM.loft.selected;
  const errors = getErrors(valid, specsVM.loft);
  return { valid, errors }
}


export function length(state, specsVM){
  let valid = specsVM.length.selected;//true;
  if(specsVM.length.selected && specsVM.length.selected.userSelection)
  {
    valid = !!(specsVM.desiredLength.selected);
  }
  
  const errors = getErrors(valid, specsVM.length);
  return { valid, errors }
}


export function reshaftLength(state, specsVM){
  let valid = true;
  
  //desiredLength must be selected if reshaft is selected
  if(specsVM.desiredLengthRequired && (specsVM.length == null || specsVM.length.selected == null || specsVM.length.selected.label !== 'Desired Length')) 
  {
	  valid = false;
  }
  	
  let reshaftLengthObj = {};	
  const errors = getErrors(valid, reshaftLengthObj);
  return { valid, errors }
}

export function grip(state, accessoriesVM){
  let valid = true;
  if(accessoriesVM.gripRequired) {
    //valid if grip not 'reuse' option
    valid = !!(accessoriesVM.grip.selected && accessoriesVM.grip.selected.id > 0 && accessoriesVM.grip.selected.sku !== 'REUSE');
  }
  const errors = getErrors(valid, accessoriesVM.grip)
  return { valid, errors }
}

export function shaftBand(state, accessoriesVM){
  let valid = true;
  if (!!accessoriesVM.restoration || !!accessoriesVM.buyAPutter.selected)
  {
    valid = !!(accessoriesVM.shaftBand.selected && accessoriesVM.shaftBand.selected.id >0);
  }
  const errors = getErrors(valid, accessoriesVM.shaftBand);
  return { valid, errors }
}

export function headCover(state, accessoriesVM){
  let valid = true;
  if (!!accessoriesVM.restoration || !!accessoriesVM.buyAPutter.selected)
  {
    valid = !!(accessoriesVM.headCover.selected && accessoriesVM.headCover.selected.id >0);
  }
  const errors = getErrors(valid, accessoriesVM.headCover);
  return { valid, errors }
}

export function buyAPutter(state, accessoriesVM){
  let valid = true;
  if (!!accessoriesVM.restoration)
  {
    valid = !!(accessoriesVM.buyAPutter.selected && accessoriesVM.buyAPutter.selected.id >0);
  }
  const errors = getErrors(valid, accessoriesVM.buyAPutter);
  return { valid, errors }
}

export function authentication(state, authenticationVM){
  const valid = (authenticationVM.selected && authenticationVM.selected.id > 0);
  const errors = getErrors(valid, authenticationVM)
  return { valid, errors }
}